import { IgTextField, type IgTextFieldProps } from "@intelligems/ig-theme";

export const TextField = ({ autoFocus, ...props }: IgTextFieldProps) => {
  // MUI's autoFocus interferes with the panel enter animation.
  // Manual focus via ref avoids this since it fires after mount.
  const ref = autoFocus
    ? (el: HTMLElement | null) =>
        el?.getElementsByTagName("input")[0]?.focus({ preventScroll: true })
    : undefined;
  return (
    <IgTextField
      fullWidth
      size="small"
      ref={ref}
      {...props}
      autoFocus={false}
    />
  );
};
